import { ActionTree, Commit, } from 'vuex'
import { ISearchState, Timeout, ILookupResult } from './types'
import {
  roundRobinPick,
  searchMenuItems,
  fetchFundSearchResults,
  FundSearchCache,
} from './utils'

const debounceTime = 300
const timeoutHandle: { debounce: Timeout } = { debounce: 0 }

export async function performSearch(searchText: string, commit: Commit, getters: any, rootGetters: any) {
  if (searchText.length < 3) {
    return;
  }
  
  const cacheSuffix = getters['cacheSuffix']
  const cache = new FundSearchCache({ keySuffix: cacheSuffix })
  const cachedFundSearchResults = cache.get(searchText)
  if (cachedFundSearchResults) {
    commit('setSelectedResultIndex', 0)
    commit('results', cachedFundSearchResults)
    commit('setCanResultPanelOpen', true)
    commit('lookup', searchText)
    return
  }

  const apiEndpoint = getters['fundSearchApiEndpoint']
  const accessToken = getters['accessToken']
  const promiseFetchFundSearchResults = fetchFundSearchResults(searchText, apiEndpoint, accessToken)

  const navData = rootGetters['NavigationState/navData']
  const eventsData = rootGetters['NavigationState/eventsData']

  let menus: any[] = []
  if (navData?.menus) { menus = menus.concat(navData?.menus) }
  if (eventsData?.menus) { menus = menus.concat(eventsData?.menus) }
  const menuResults = searchMenuItems(searchText, menus)
  commit('lookup', searchText)

  const fundSearchResults = await promiseFetchFundSearchResults;
  const grandResult = [...fundSearchResults, menuResults]
  let finalResult: ILookupResult[][] = []
  if (fundSearchResults.reduce((a, c) => a + c.length, 0) > 0) {
    finalResult = roundRobinPick(grandResult, 15)
    commit('setSelectedResultIndex', 0)
    commit('results', finalResult)
    commit('setCanResultPanelOpen', true)
  }
  const mustHaveCacheSuffix = getters['mustHaveCacheSuffix']
  if (!mustHaveCacheSuffix || !!cacheSuffix) {
    cache.set(searchText, finalResult)
  }
  cache.flushExpired()
}

const actions: ActionTree<ISearchState, any> = {
  selectPreviousResult({commit, getters}) {
    const current = getters.selectedResultIndex;
    if (current <= 0) return
    commit('setSelectedResultIndex', current - 1)
  },
  selectNextResult({commit, getters}) {
    const current = getters.selectedResultIndex;
    const results = getters.results
    const upperBound = results?.reduce((a: number, c: any[]) => a+c.length, 0)||0;
    if (current >= upperBound-1) return
    commit('setSelectedResultIndex', current + 1)
  },
  invokeActionOnSelectedResult({getters, commit}) {
    const result: ILookupResult = getters.selectedResult
    if (result) {
      const {href, target} = result
      window.open(href, target)
      commit('setCanResultPanelOpen', false)
    }
  },
  async lookup({ commit, getters, rootGetters }, searchText: string) {
    if (timeoutHandle.debounce) {
      clearTimeout(timeoutHandle.debounce)
      timeoutHandle.debounce = 0
    }
    timeoutHandle.debounce = setTimeout(async () => await performSearch(searchText, commit, getters, rootGetters), debounceTime)
  },
}


export default actions
